module.exports = "https://coursera_assets.s3.amazonaws.com/images/732d98502a7109bf690a49121aad3bbf.png";